import React, {Fragment} from "react";
import ReactsCard from "../components/ui/ReactsCard";
import {useTranslation} from "react-i18next";
import {GoBackButton} from "../components/ui/GoBackButton";
import {useQuery} from "../utils/function-util";
import {WithOrganization} from "../components/organizations/organization-context";
import {Navigate, useNavigate} from "react-router-dom";
import {makeStyles} from "@material-ui/core/styles";
import {ProGroupCreationWizard} from "../components/pro-guest/groups/add-group/ProGroupCreationWizard";
import Button from "@material-ui/core/Button";
import {ArrowBackIos} from "@material-ui/icons";
import {FolderHierarchyBreadcrumbs} from "../components/pro-guest/shared/folder-hierarchy-breadcrumb/FolderHieararchyBreadcrums";

const useStyles = makeStyles(theme => ({
    root: {
        margin: theme.spacing(4),
        '& > *': {
            'margin-bottom': theme.spacing(4)
        }
    },
    top: {
        display: 'flex',
        flexDirection: 'row',
        flexGrow: 1,
        alignItems: 'center'
    },
    wizardCard: {
        minWidth: 250,
        margin: theme.spacing(4)
    }
}));

export const ProGroupWizardAdd: React.FC<WithOrganization> = ({currentOrganization}) => {
    const query = useQuery();
    const folderId = query.get('folderId');
    const {t} = useTranslation();
    const navigate = useNavigate();
    const classes = useStyles();

    const goBack = () => {
        navigate(`/pro-guests?folderId=${folderId}&tabId=${1}`);
    };

    const getTitle =
        <Fragment>
            <GoBackButton goBack={goBack}/>
            {t('ProGuest.Groups.AddTitle')}
        </Fragment>

    if (!currentOrganization || !folderId || isNaN(parseInt(folderId))) {
        const returnUrl = encodeURIComponent(getReturnUrl(folderId));
        const redirectUrl = `/organizations?returnUrl=${returnUrl}`;
        return <Navigate to={redirectUrl} replace={false} />;
    }

    return <div className={classes.root}>
        <div className={classes.top}>
            <Button onClick={goBack}>
                <ArrowBackIos color="primary"/>
            </Button>
            <FolderHierarchyBreadcrumbs organizationId={currentOrganization.id}
                                        folderId={folderId}/>
        </div>
        <ReactsCard title={getTitle} className={classes.wizardCard}>
            <ProGroupCreationWizard goBack={goBack} organizationId={currentOrganization.id} folderId={parseInt(folderId)}/>
        </ReactsCard>
    </div>
}

const getReturnUrl = (folderId: any) => {
    if (folderId) {
        return `/pro-guests/groups/add?folderId=${folderId}`
    }
    return `/pro-guests/`;
}
